<div class="ibox detailed-view-ibox">
    <div class="detailed-view-header">
        <div class="col-sm-9">
            <span>Pet</span>
        </div>
        <div class="col-sm-3" *ngIf="parent.suiteData && parent.directoryService.account.canUpdate('bldn', parent.suiteData.building.id)">
            <button type="button" class="btn btn-w-m btn-primary pull-right" (click)="create()">
                <i class="fa fa-plus-circle"></i> Add Pet
            </button>
        </div>
    </div>

    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form *ngIf="data"
                  #form="ngForm"
                  (ngSubmit)="update(form)"
                  [ngClass]="{'ng-submitted': form.submitted}"
                  autocomplete="off">
                <span *ngIf="parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                      class="label archived-item m-b-sm">
                    Archived
                </span>

                <select-field [ngModel]="data.petType"
                              name="petType"
                              [title]="'Pet Type'"
                              [optionTitleKey]="'name'"
                              [data]="petsList"
                              [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                              (update)="update({petType: form.value.petType})">
                </select-field>

                <input-field [ngModel]="data.name"
                             name="name"
                             [required]="true"
                             [title]="'Name'"
                             [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                             (update)="update({name: form.value.name});
                                       updateNameInList('petsList', data.id, 'name',form.value.name)">
                </input-field>

                <input-field [ngModel]="data.weight"
                             name="weight"
                             [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                             [title]="'Weight'"
                             (update)="update({weight: form.value.weight})">
                </input-field>

                <input-field [ngModel]="data.height"
                             name="height"
                             [title]="'Height'"
                             [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                             (update)="update({height: form.value.height})">
                </input-field>

                <input-field [ngModel]="data.breed"
                             name="breed"
                             [title]="'Breed'"
                             [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                             (update)="update({breed: form.value.breed})">
                </input-field>

                <datetime-field [ngModel]="data.dateOfBirth"
                                name="dateOfBirth"
                                [title]="'DOB'"
                                [value]="data.dateOfBirth"
                                [classLabel]="'dv-label col-sm-3 strong'"
                                [classValueBox]="'dv-value col-sm-9'"
                                [classValueEditBox]="'dv-value-edit col-sm-9'"
                                [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                                (update)="update({dateOfBirth: convertDate(form.value.dateOfBirth)})">
                </datetime-field>

                <datetime-field [ngModel]="data.moveOutDate"
                                name="moveOutDate"
                                [title]="'Move Out Date'"
                                [value]="data.moveOutDate"
                                [classLabel]="'dv-label col-sm-3 strong'"
                                [classValueBox]="'dv-value col-sm-9'"
                                [classValueEditBox]="'dv-value-edit col-sm-9'"
                                [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                                (update)="update({moveOutDate: convertDate(form.value.moveOutDate)})">
                </datetime-field>

                <textarea-field [ngModel]="data.note"
                                [value]="data.note"
                                [maxLength]="255"
                                name="note"
                                [title]="'Notes'"
                                [noEdit]="!data.isCanEdit || parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                                (update)="update({note: form.value.note})">
                </textarea-field>

                <div class="btn-group" *ngIf="data.id && data.isCanDelete">
                    <a data-toggle="dropdown" class="btn btn-default btn-sm dropdown-toggle">
                        Actions <span class="caret"></span>
                    </a>
                    <ul class="dropdown-menu">
                        <li>
                            <a (click)="remove()">Delete</a>
                        </li>
                        <li (click)="moveOut(title)"
                            *ngIf="data.isCanDelete && (!data.moveOutDate || parent.directoryService.dateIsLaterThanCurrent(data.moveOutDate))">
                            <a>Move Out</a>
                        </li>
                        <li (click)="restore()"
                            *ngIf="data.isCanEdit && parent.directoryService.dateIsEarlierThanCurrent(data.moveOutDate)">
                            <a>Restore</a>
                        </li>
                    </ul>
                </div>

            </form>
        </div>
    </div>
    <spinner [spinnerShow]="parent.spinnerShow"></spinner>
</div>

<div class="boxForModal" *ngIf="isCreateModal && parent.suiteData">
    <pet-create [closeTrigger]="hideModal"
                (onPopupClose)="hideModal()"
                [buildingId]="parent.suiteData.building.id"
                [suiteId]="parent.suiteData.id"
                [inDirectoryItemView]="true">
    </pet-create>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/directory-item/pets/pets.template.html